module.exports = __webpack_public_path__ + "static/img/logo.f5b2166c.svg";